/* src/app/shared/components/tracking-tracker-filter-panel/tracking-tracker-filter-panel.component.scss */
button.search {
  background-color: #E86D0C;
  border-radius: 5px;
  border: 0;
  height: 40px;
}
button.search i {
  color: #FFFFFF;
  padding: 2px;
}
button.clear {
  min-width: 0;
}
button.search:disabled {
  background-color: #D8D8D8;
}
.icon-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
}
.icon-button i {
  font-size: 20px;
  vertical-align: middle;
}
.search.clear-btn {
  margin-left: 5px;
}
.search.clear-btn[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}
/*# sourceMappingURL=tracking-tracker-filter-panel.component.css.map */
